var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 203.029,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 105.94
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M473.651,88.257H38.292c-20.485,0-37.215,16.062-38.292,36.277v21.109h512v-19.037 C512,105.427,494.831,88.257,473.651,88.257z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 145.639,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 57.39
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M0,387.466c1.077,20.215,17.807,36.277,38.292,36.277h435.359c21.18,0,38.349-17.169,38.349-38.349 v-19.037H0V387.466z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 308.969,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 57.39
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 138.41,
    cy: 255.999,
    rx: 41.3,
    ry: 44.14
  })), /*#__PURE__*/React.createElement("rect", {
    x: 117.05,
    y: 238.909,
    style: {
      fill: "#3CC8FF"
    },
    width: 42.719,
    height: 21.36
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "122.746,251.058 123.234,255.771 125.153,251.44 124.161,256.072 127.325,252.546  124.949,256.645 129.047,254.27 125.522,257.434 130.154,256.44 125.824,258.361 130.536,258.848 125.824,259.335 130.154,261.255  125.522,260.262 129.047,263.427 124.949,261.051 127.325,265.15 124.161,261.624 125.153,266.257 123.234,261.925 122.746,266.637  122.258,261.925 120.339,266.257 121.331,261.624 118.167,265.15 120.542,261.051 116.443,263.427 119.969,260.262 115.338,261.255  119.668,259.335 114.956,258.848 119.668,258.361 115.338,256.44 119.969,257.434 116.443,254.27 120.542,256.645 118.167,252.546  121.331,256.072 120.339,251.44 122.258,255.771 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "146.953,290.176 129.866,290.176 114.202,277.36 114.202,258.848 164.04,258.848  164.04,277.36 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M155.497,253.152h-0.001c-0.004-0.39-0.32-0.704-0.711-0.704c-0.391,0-0.705,0.315-0.711,0.704 h-0.001c0,2.471-1.432,5.89-3.188,8.337c-2.452-3.097-3.375-6.687-3.722-8.948c-0.166-1.078-1.331-1.676-2.308-1.189 c-0.47,0.235-0.787,0.694-0.867,1.213c-1.09,6.983-4.382,9.951-6.514,11.171c-3.192-3.086-4.243-8.079-4.59-11.031 c-0.135-1.148-1.363-1.807-2.397-1.29c-0.398,0.199-0.693,0.558-0.832,0.981c-4.466,13.615-16.877,14.994-16.877,14.994v4.272 h49.838v-1.424v-1.424v-1.424v-1.424v-1.424C156.921,263.12,155.497,253.152,155.497,253.152z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0AA00"
    },
    d: "M162.617,240.336c-5.696-2.848-5.696-5.696-5.696-5.696s-7.12-2.848-12.816-2.848 c0,0,1.424-2.848-1.424-2.848c-2.848,0-4.272,0-4.272,0s-1.424,0-4.272,0s-1.424,2.848-1.424,2.848 c-5.696,0-12.816,2.848-12.816,2.848s0,2.848-5.696,5.696c-5.696,2.848-5.696,9.256-5.696,9.256c0,1.18,0.957,2.135,2.135,2.135 c1.18,0,2.135-0.957,2.135-2.135c0-0.244-0.05-0.473-0.125-0.691l0.125-0.021l14.239-9.967h11.392h11.392l14.239,9.967l0.125,0.021 c-0.075,0.217-0.125,0.448-0.125,0.691c0,1.18,0.957,2.135,2.135,2.135s2.135-0.957,2.135-2.135 C168.312,249.593,168.312,243.184,162.617,240.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0AA00"
    },
    d: "M166.889,257.424c-1.424,0-5.696,0-5.696-4.272s5.696-4.272,5.696-4.272l-8.544-2.848 c-2.848,9.967,2.848,9.967,2.848,22.783c0,11.48-12.816,18.511-17.088,18.511s-5.696,2.848-5.696,2.848s-1.424-2.848-5.696-2.848 s-17.088-7.031-17.088-18.511c0-12.816,5.696-12.816,2.848-22.783l-8.544,2.848c0,0,5.696,0,5.696,4.272s-4.272,4.272-5.696,4.272 s-7.12,0-7.12,7.12s7.12,15.664,17.088,21.36s5.696,11.392,18.511,11.392s8.544-5.696,18.511-11.392 c9.967-5.696,17.088-14.239,17.088-21.36C174.009,257.424,168.312,257.424,166.889,257.424z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M135.562,235.136l-3.444-1.548c-0.572-0.257-1.206-0.317-1.816-0.175 c-2.22,0.513-7.728,2.201-11.827,6.924l4.272,1.424L135.562,235.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M141.257,235.136l3.444-1.548c0.572-0.257,1.206-0.317,1.816-0.175 c2.22,0.513,7.728,2.201,11.827,6.924l-4.272,1.424L141.257,235.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M138.913,236.064l2.597-2.597c0.139-0.139,0.139-0.364,0-0.503s-0.364-0.139-0.503,0l-2.597,2.597 l-2.597-2.597c-0.139-0.139-0.364-0.139-0.503,0s-0.139,0.364,0,0.503l2.597,2.597l-2.597,2.597c-0.139,0.139-0.139,0.364,0,0.503 c0.07,0.07,0.161,0.105,0.252,0.105s0.182-0.035,0.252-0.105l2.597-2.597l2.597,2.597c0.07,0.07,0.161,0.105,0.252,0.105 c0.092,0,0.182-0.035,0.252-0.105c0.139-0.139,0.139-0.364,0-0.503L138.913,236.064z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M166.889,248.88c0-2.422-2.289-3.47-4.272-3.924v-1.128c-2.681-0.252-4.176-1.258-6.776-3.029 c-1.001-0.683-2.137-1.456-3.507-2.289c-5.007-3.041-8.855-3.481-11.077-3.375v2.353h-5.696v-2.353 c-2.221-0.106-6.07,0.333-11.077,3.375c-1.371,0.833-2.506,1.606-3.507,2.289c-2.599,1.77-4.094,2.778-6.776,3.029v1.128 c-1.983,0.454-4.272,1.501-4.272,3.924l4.272-1.424v0.649c4.041-0.298,6.352-1.848,9.181-3.775c0.959-0.653,2.045-1.394,3.32-2.167 c3.252-1.977,5.779-2.588,7.435-2.732v2.331h8.544v-2.331c1.655,0.145,4.183,0.756,7.435,2.732c1.275,0.775,2.362,1.514,3.32,2.167 c2.828,1.927,5.139,3.478,9.181,3.775v-0.649L166.889,248.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC8FF"
    },
    d: "M155.497,226.435v-1.762h-3.966c0.693-0.595,1.119-1.296,1.119-2.135 c0-3.934-8.951-4.984-14.239-4.984s-14.239,1.049-14.239,4.984c0,0.84,0.426,1.541,1.119,2.135h-3.966v1.762 c-3.486,0.778-6.336,2.649-6.486,2.749l1.579,2.369c0.039-0.026,3.957-2.609,7.754-2.609v-1.424h28.479v1.424 c3.797,0,7.715,2.582,7.754,2.609l1.579-2.369C161.833,229.084,158.983,227.212,155.497,226.435z M144.106,224.279v-1.081 c0-0.697-0.656-1.208-1.331-1.04l-4.365,1.091l-4.365-1.091c-0.676-0.169-1.331,0.342-1.331,1.04v1.081 c-3.199-0.47-5.091-1.253-5.606-1.741c0.77-0.732,4.543-2.135,11.302-2.135c6.758,0,10.531,1.405,11.302,2.135 C149.196,223.026,147.304,223.809,144.106,224.279z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M138.588,242.298l0.361,1.081l1.14,0.009c0.148,0.001,0.209,0.19,0.09,0.277l-0.917,0.678 l0.344,1.087c0.044,0.141-0.116,0.257-0.236,0.171l-0.928-0.663l-0.928,0.663c-0.12,0.086-0.28-0.031-0.236-0.171l0.344-1.087 l-0.917-0.678c-0.119-0.087-0.057-0.276,0.09-0.277l1.14-0.009l0.361-1.081C138.343,242.158,138.54,242.158,138.588,242.298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M133.005,242.662l0.472,1.038l1.136-0.11c0.147-0.014,0.227,0.167,0.119,0.266l-0.841,0.77 l0.456,1.045c0.06,0.136-0.088,0.268-0.216,0.195l-0.992-0.562l-0.853,0.757c-0.11,0.098-0.283-0.001-0.253-0.146l0.228-1.118 l-0.983-0.577c-0.127-0.075-0.086-0.268,0.061-0.285l1.133-0.128l0.245-1.114C132.746,242.549,132.944,242.529,133.005,242.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M127.273,244.19l0.686,0.912l1.084-0.354c0.14-0.046,0.258,0.114,0.173,0.234l-0.654,0.934 l0.672,0.921c0.087,0.119-0.028,0.28-0.169,0.237l-1.09-0.334l-0.669,0.924c-0.086,0.119-0.276,0.06-0.278-0.087l-0.02-1.14 l-1.085-0.351c-0.14-0.045-0.142-0.244-0.002-0.291l1.078-0.371l-0.002-1.14C126.996,244.135,127.184,244.072,127.273,244.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M121.528,246.612l0.8,0.812l1.027-0.494c0.134-0.064,0.271,0.078,0.203,0.21l-0.525,1.012 l0.788,0.824c0.102,0.107,0.01,0.281-0.136,0.258l-1.126-0.187l-0.541,1.004c-0.07,0.13-0.265,0.096-0.287-0.05l-0.17-1.128 l-1.122-0.204c-0.146-0.026-0.173-0.223-0.041-0.289l1.02-0.51l-0.152-1.13C121.246,246.594,121.424,246.506,121.528,246.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M143.878,242.662l-0.472,1.038l-1.136-0.11c-0.147-0.014-0.227,0.167-0.119,0.266l0.841,0.77 l-0.456,1.045c-0.06,0.136,0.088,0.268,0.216,0.195l0.992-0.562l0.853,0.757c0.11,0.098,0.283-0.001,0.253-0.146l-0.228-1.118 l0.983-0.577c0.127-0.075,0.086-0.268-0.061-0.285l-1.133-0.128l-0.245-1.114C144.136,242.549,143.939,242.529,143.878,242.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M149.61,244.19l-0.686,0.912l-1.084-0.354c-0.14-0.046-0.258,0.114-0.173,0.234l0.654,0.934 l-0.672,0.921c-0.087,0.119,0.028,0.28,0.169,0.237l1.09-0.334l0.669,0.924c0.086,0.119,0.276,0.06,0.278-0.087l0.02-1.14 l1.085-0.351c0.14-0.045,0.142-0.244,0.002-0.291l-1.078-0.371l0.002-1.14C149.887,244.135,149.698,244.072,149.61,244.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M155.355,246.612l-0.8,0.812l-1.027-0.494c-0.134-0.064-0.271,0.078-0.203,0.21l0.525,1.012 l-0.788,0.824c-0.102,0.107-0.01,0.281,0.136,0.258l1.126-0.187l0.541,1.004c0.07,0.13,0.265,0.096,0.287-0.05l0.17-1.128 l1.122-0.204c0.146-0.026,0.173-0.223,0.041-0.289l-1.02-0.51l0.152-1.13C155.637,246.594,155.459,246.506,155.355,246.612z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C5A28"
    },
    points: "128.575,276.469 135.829,281.32 144.594,281.32 148.645,277.849 145.529,279.095  135.205,279.095 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M133.515,270.21l-0.7,7.061l-3.186-1.216C129.628,276.054,131.094,272.652,133.515,270.21z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 139.8,
    y: 267.419,
    style: {
      fill: "#8C5A28"
    },
    width: 0.471,
    height: 12.02
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.16,
    y: 268.429,
    style: {
      fill: "#8C5A28"
    },
    width: 0.471,
    height: 11.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.46,
    y: 268.429,
    style: {
      fill: "#8C5A28"
    },
    width: 0.471,
    height: 11.01
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M141.478,278.294h-2.877c-0.299,0-0.542-0.243-0.542-0.542v-1.453c0-0.299,0.243-0.542,0.542-0.542 h2.877c0.299,0,0.542,0.243,0.542,0.542v1.453C142.02,278.052,141.777,278.294,141.478,278.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M141.478,274.912h-2.877c-0.299,0-0.542-0.243-0.542-0.542v-1.453c0-0.299,0.243-0.542,0.542-0.542 h2.877c0.299,0,0.542,0.243,0.542,0.542v1.453C142.02,274.669,141.777,274.912,141.478,274.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M141.478,271.798h-2.877c-0.299,0-0.542-0.243-0.542-0.542v-1.453c0-0.299,0.243-0.542,0.542-0.542 h2.877c0.299,0,0.542,0.243,0.542,0.542v1.453C142.02,271.555,141.777,271.798,141.478,271.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M145.568,278.294h-2.343c-0.299,0-0.542-0.243-0.542-0.542v-1.453c0-0.299,0.243-0.542,0.542-0.542 h2.343c0.299,0,0.542,0.243,0.542,0.542v1.453C146.11,278.052,145.867,278.294,145.568,278.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M145.568,275.18h-2.343c-0.299,0-0.542-0.243-0.542-0.542v-1.055c0-0.299,0.243-0.542,0.542-0.542 h2.343c0.299,0,0.542,0.243,0.542,0.542v1.055C146.11,274.937,145.867,275.18,145.568,275.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M145.568,272.094h-2.343c-0.299,0-0.542-0.243-0.542-0.542v-0.712c0-0.299,0.243-0.542,0.542-0.542 h2.343c0.299,0,0.542,0.243,0.542,0.542v0.712C146.11,271.852,145.867,272.094,145.568,272.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M136.867,278.294h-2.343c-0.299,0-0.542-0.243-0.542-0.542v-1.453c0-0.299,0.243-0.542,0.542-0.542 h2.343c0.299,0,0.542,0.243,0.542,0.542v1.453C137.409,278.052,137.166,278.294,136.867,278.294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M136.867,275.18h-2.343c-0.299,0-0.542-0.243-0.542-0.542v-1.055c0-0.299,0.243-0.542,0.542-0.542 h2.343c0.299,0,0.542,0.243,0.542,0.542v1.055C137.409,274.937,137.166,275.18,136.867,275.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M136.867,272.094h-2.343c-0.299,0-0.542-0.243-0.542-0.542v-0.712c0-0.299,0.243-0.542,0.542-0.542 h2.343c0.299,0,0.542,0.243,0.542,0.542v0.712C137.409,271.852,137.166,272.094,136.867,272.094z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "135.93,268.432 135.93,269.853 138.024,269.129  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "144.625,268.432 144.625,269.853 146.719,269.129  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "140.27,267.41 140.27,268.831 142.363,268.107  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C5A28"
    },
    points: "134.709,257.801 137.228,259.486 140.274,259.486 141.681,258.28 140.598,258.713  137.012,258.713 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M136.425,255.626l-0.243,2.453l-1.107-0.423C135.074,257.657,135.584,256.475,136.425,255.626z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 138.61,
    y: 254.649,
    style: {
      fill: "#8C5A28"
    },
    width: 0.163,
    height: 4.177
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.12,
    y: 254.999,
    style: {
      fill: "#8C5A28"
    },
    width: 0.163,
    height: 3.824
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.1,
    y: 254.999,
    style: {
      fill: "#8C5A28"
    },
    width: 0.163,
    height: 3.824
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M139.19,258.435h-1c-0.104,0-0.189-0.084-0.189-0.189v-0.504c0-0.104,0.084-0.189,0.189-0.189h1 c0.104,0,0.189,0.084,0.189,0.189v0.504C139.379,258.351,139.295,258.435,139.19,258.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M139.19,257.259h-1c-0.104,0-0.189-0.084-0.189-0.189v-0.504c0-0.104,0.084-0.189,0.189-0.189h1 c0.104,0,0.189,0.084,0.189,0.189v0.504C139.379,257.175,139.295,257.259,139.19,257.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M139.19,256.178h-1c-0.104,0-0.189-0.084-0.189-0.189v-0.504c0-0.104,0.084-0.189,0.189-0.189h1 c0.104,0,0.189,0.084,0.189,0.189v0.504C139.379,256.093,139.295,256.178,139.19,256.178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M140.612,258.435h-0.814c-0.104,0-0.189-0.084-0.189-0.189v-0.504c0-0.104,0.084-0.189,0.189-0.189 h0.814c0.104,0,0.189,0.084,0.189,0.189v0.504C140.799,258.351,140.715,258.435,140.612,258.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M140.612,257.353h-0.814c-0.104,0-0.189-0.084-0.189-0.189v-0.366c0-0.104,0.084-0.189,0.189-0.189 h0.814c0.104,0,0.189,0.084,0.189,0.189v0.366C140.799,257.268,140.715,257.353,140.612,257.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M140.612,256.28h-0.814c-0.104,0-0.189-0.084-0.189-0.189v-0.247c0-0.104,0.084-0.189,0.189-0.189 h0.814c0.104,0,0.189,0.084,0.189,0.189v0.247C140.799,256.197,140.715,256.28,140.612,256.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M137.589,258.435h-0.814c-0.104,0-0.189-0.084-0.189-0.189v-0.504c0-0.104,0.084-0.189,0.189-0.189 h0.814c0.104,0,0.189,0.084,0.189,0.189v0.504C137.777,258.351,137.693,258.435,137.589,258.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M137.589,257.353h-0.814c-0.104,0-0.189-0.084-0.189-0.189v-0.366c0-0.104,0.084-0.189,0.189-0.189 h0.814c0.104,0,0.189,0.084,0.189,0.189v0.366C137.777,257.268,137.693,257.353,137.589,257.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M137.589,256.28h-0.814c-0.104,0-0.189-0.084-0.189-0.189v-0.247c0-0.104,0.084-0.189,0.189-0.189 h0.814c0.104,0,0.189,0.084,0.189,0.189v0.247C137.777,256.197,137.693,256.28,137.589,256.28z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "137.263,255.008 137.263,255.502 137.991,255.251  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "140.284,255.008 140.284,255.502 141.011,255.251  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "138.771,254.653 138.771,255.147 139.498,254.895  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M132.925,250.305h-1.848c-0.667,0-1.212-0.545-1.212-1.212l0,0c0-0.667,0.545-1.212,1.212-1.212 h1.848c0.667,0,1.212,0.545,1.212,1.212l0,0C134.138,249.759,133.592,250.305,132.925,250.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M146.981,250.305h-1.219c-0.669,0-1.212-0.543-1.212-1.212l0,0c0-0.669,0.543-1.212,1.212-1.212 h1.219c0.669,0,1.212,0.543,1.212,1.212l0,0C148.193,249.762,147.65,250.305,146.981,250.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M155.639,252.129h-1.074c-0.383,0-0.693-0.31-0.693-0.693v-0.115c0-0.383,0.31-0.693,0.693-0.693 h1.074c0.383,0,0.693,0.31,0.693,0.693v0.115C156.332,251.819,156.022,252.129,155.639,252.129z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCr);
export default __webpack_public_path__ + "static/media/cr.c8c65960ceb8f5ab6d40a1f82cbefeb0.svg";
export { ForwardRef as ReactComponent };